<template>
  <div class="rider-check" :class="{ 'rider-check--plain': riderState !== 'active' }">
    <!-- 校验中：不渲染页面其他内容，避免表单闪现 -->
    <div v-if="riderState === 'checking'" class="state-box">
      <div class="state-card">
        <van-loading class="state-loading" color="#ff7a3c" size="28px">
          正在校验骑手身份...
        </van-loading>
      </div>
    </div>

    <!-- 非活跃骑手：只展示提示文案，其余内容一律不展示 -->
    <div v-else-if="riderState === 'rejected'" class="state-box">
      <div class="state-card">
        <van-icon class="state-icon" name="warning-o" />
        <div class="state-text">非活跃骑手无法访问</div>
      </div>
    </div>

    <!-- 活跃骑手：展示正常领取表单 -->
    <template v-else>
    <div class="banner"></div>

    <div class="form-box">
      <div class="form-item">
        <div class="form-label">
          <img class="label-icon" src="@/assets/eleme/name.png" alt="" />
          <span>昵称</span>
        </div>
        <input
          class="form-input"
          v-model="name"
          type="text"
          maxlength="32"
          placeholder="请输入您的姓名"
        />
      </div>

      <div class="form-item">
        <div class="form-label">
          <img class="label-icon" src="@/assets/eleme/tel.png" alt="" />
          <span>联系电话</span>
        </div>
        <input
          class="form-input"
          v-model="phone"
          type="tel"
          maxlength="11"
          placeholder="请输入联系电话"
        />
      </div>

      <div class="form-item">
        <div class="form-label">
          <img class="label-icon" src="@/assets/eleme/id.png" alt="" />
          <span>身份证号码</span><span style="color: #5c6065; font-size: 13px">(仅用于校验办理资格)</span>
        </div>
        <input
          class="form-input"
          v-model="cardId"
          type="text"
          maxlength="18"
          placeholder="请输入身份证号码"
        />
      </div>

      <div class="form-item">
        <div class="form-label">
          <van-icon class="label-icon" name="location-o" />
          <span>城市</span>
        </div>
        <input
          class="form-input"
          readonly
          :value="cityName"
          placeholder="请选择城市"
          @click="showCity = true"
        />
      </div>

      <button class="submit-btn" @click="onSubmit">领取福利</button>

<!--      <div class="query-entry" @click="goOrderList">订单查询</div>-->
    </div>

    <!-- 城市选择弹层 -->
    <van-popup v-model="showCity" position="bottom" :style="{ height: '75%' }">
      <div class="city-popup">
        <van-search v-model="cityKeyword" placeholder="搜索城市名称" />
        <div class="city-grid" v-if="filteredCities.length">
          <div
            v-for="c in filteredCities"
            :key="c.id"
            class="city-grid-item"
            @click="selectCity(c)"
          >
            {{ c.name }}
          </div>
        </div>
        <div class="city-empty" v-else>未找到相关城市</div>
      </div>
    </van-popup>

    <!-- 系统维护弹窗（维护时段内不可关闭） -->
    <van-dialog
      v-model="showMaintain"
      class="maintain-dialog"
      :show-confirm-button="false"
      :show-cancel-button="false"
      :close-on-click-overlay="false"
      :close-on-popstate="false"
    >
      <div class="maintain-body">
        <van-icon class="maintain-icon" name="underway-o" />
        <div class="maintain-text">{{ maintainTip }}</div>
        <div class="maintain-countdown" v-if="maintainRemain">
          距离{{ maintainEndText }}恢复还有
          <span class="maintain-countdown-time">{{ maintainRemain }}</span>
        </div>
      </div>
    </van-dialog>

    <!-- 领取成功弹窗（不展示口令，只引导添加客服微信） -->
    <van-dialog v-model="showSuccess" :show-confirm-button="false" class="rider-dialog">
      <div class="dialog-body">
        <div class="dialog-text">
          <div>请添加微信客服获取<span class="dialog-bold">【口令】</span><br /><span class="dialog-red">并进入下一步操作</span></div>
        </div>
        <img class="dialog-qr" src="@/assets/eleme/kefuQRCode.png" alt="客服二维码" />
        <div class="dialog-close" @click="showSuccess = false">关闭</div>
      </div>
    </van-dialog>

    <!-- 校验失败弹窗 -->
    <van-dialog v-model="showFail" :show-confirm-button="false" class="rider-dialog">
      <div class="dialog-body">
        <div class="dialog-text">骑手身份校验不通过，您无法领取通讯大礼包！</div>
        <div class="dialog-close" @click="showFail = false">关闭</div>
      </div>
    </van-dialog>

    <!-- 重复领取弹窗（不展示口令，只引导添加客服微信） -->
    <van-dialog v-model="showDuplicate" :show-confirm-button="false" class="rider-dialog">
      <div class="dialog-body">
        <div class="dialog-text">
          <div>请添加微信客服获取<span class="dialog-bold">【口令】</span><br /><span class="dialog-red">并进入下一步操作</span></div>
        </div>
        <img class="dialog-qr" src="@/assets/eleme/kefuQRCode.png" alt="客服二维码" />
        <div class="dialog-close" @click="showDuplicate = false">关闭</div>
      </div>
    </van-dialog>
    </template>
  </div>
</template>

<script>
import { Popup, Search, Icon, Toast, Dialog, Loading } from "vant";
import { http } from "@/api/http";
import { getUrlParams } from "@/utils/url";
import { setSpiId } from "@/utils/spi";

// 系统维护时段：维护开始小时 ~ 次日恢复小时（改这一个地方，弹窗文案会自动跟着变）
const MAINTAIN_START_HOUR = 22;
const MAINTAIN_END_HOUR = 9;

// 骑手礼包订单归属的供应商（广东电信），订单查询页固定按此 spiId 查询
const RIDER_ORDER_SPI_ID = "guangzhou-telecom-01";

function pad2(n) {
  return n < 10 ? "0" + n : String(n);
}

export default {
  name: "ElemeRiderCheck",
  components: {
    vanPopup: Popup,
    vanSearch: Search,
    vanIcon: Icon,
    vanLoading: Loading,
    [Dialog.Component.name]: Dialog.Component,
  },
  data() {
    return {
      gdCities: [
        { id: "4", name: "广州" },
        { id: "11", name: "深圳" },
        { id: "26", name: "珠海" },
        { id: "200", name: "汕头" },
        { id: "24", name: "佛山" },
        { id: "72", name: "韶关" },
        { id: "79", name: "湛江" },
        { id: "64", name: "肇庆" },
        { id: "130", name: "江门" },
        { id: "123", name: "茂名" },
        { id: "57", name: "惠州" },
        { id: "56", name: "梅州" },
        { id: "544", name: "汕尾" },
        { id: "365", name: "河源" },
        { id: "202", name: "阳江" },
        { id: "371", name: "清远" },
        { id: "51", name: "东莞" },
        { id: "203", name: "中山" },
        { id: "235", name: "潮州" },
        { id: "231", name: "揭阳" },
        { id: "421", name: "云浮" }
      ],
      name: "",
      cardId: "",
      cityId: "",
      cityName: "",
      phone: "",
      // 饿了么/美团用户加密ID，由 App.vue 从地址栏 openId 透传过来
      openId: "",
      showCity: false,
      cityKeyword: "",
      showSuccess: false,
      showFail: false,
      showDuplicate: false,
      showMaintain: false,
      maintainRemain: "",
      maintainTimer: null,
      // checking-校验中 / active-活跃骑手 / rejected-非活跃骑手（只展示提示文案）
      riderState: "checking",
    };
  },
  computed: {
    filteredCities() {
      const kw = this.cityKeyword.trim();
      if (!kw) return this.gdCities;
      return this.gdCities.filter((c) => c.name.indexOf(kw) > -1);
    },
    // 维护开始时间文案，如 22:00（跟随 MAINTAIN_START_HOUR）
    maintainStartText() {
      return pad2(MAINTAIN_START_HOUR) + ":00";
    },
    // 恢复时间文案，如 15:00（跟随 MAINTAIN_END_HOUR）
    maintainEndText() {
      return pad2(MAINTAIN_END_HOUR) + ":00";
    },
    // 弹窗/Toast 文案统一由此生成，避免写死
    maintainTip() {
      return (
        "每晚" +
        this.maintainStartText +
        "到次日" +
        this.maintainEndText +
        "系统要维护休息啦，请您" +
        this.maintainEndText +
        "之后再来操作哦"
      );
    },
  },
  created() {
    this.initOpenId();
    // 进入页面先校验骑手是否活跃（按 openId），校验通过才展示领取表单
    this.checkRiderActive();
  },
  beforeDestroy() {
    if (this.maintainTimer) {
      clearInterval(this.maintainTimer);
      this.maintainTimer = null;
    }
    document.removeEventListener("visibilitychange", this.checkMaintain);
  },
  methods: {
    // 取 openId：优先路由 query（App.vue 透传），其次 hash 上的 openId，最后回落 localStorage
    initOpenId() {
      const fromQuery = (this.$route && this.$route.query && this.$route.query.openId) || "";
      const fromHash = getUrlParams().openId || "";
      const fromStore = localStorage.getItem("mtBmUid") || "";
      this.openId = fromQuery || fromHash || fromStore;
      console.log("ElemeRiderCheck openId =>", this.openId);
    },
    // 进入页面按 openId 校验骑手是否活跃：活跃才展示领取表单，
    // 非活跃（或校验失败、缺少 openId）只展示「非活跃骑手无法访问」
    async checkRiderActive() {
      if (!this.openId) {
        console.warn("ElemeRiderCheck 缺少 openId，按非活跃骑手处理");
        this.riderState = "rejected";
        return;
      }
      try {
        const res = await http(
          "checkElemeRiderActive",
          { mtBmUid: this.openId },
          { hideLoading: true }
        );
        if (res && res.code === 200 && res.result === true) {
          this.riderState = "active";
          this.startMaintainWatch();
        } else {
          console.warn("ElemeRiderCheck 骑手活跃校验未通过 =>", res);
          this.riderState = "rejected";
        }
      } catch (e) {
        console.error("ElemeRiderCheck 骑手活跃校验异常 =>", e);
        this.riderState = "rejected";
      }
    },
    // 骑手活跃校验通过后才开始维护时段监测（非活跃骑手页面不渲染维护弹窗）
    startMaintainWatch() {
      this.checkMaintain();
      // 每秒检测一次：到点自动弹出 / 到点自动消失（实测延迟不超过 1s，且改系统时间也能立即生效）
      this.maintainTimer = setInterval(this.checkMaintain, 1000);
      // 页面从后台切回前台时立即校准一次，避免定时器被浏览器节流导致状态滞后
      document.addEventListener("visibilitychange", this.checkMaintain);
    },
    checkMaintain() {
      const t = this.nowParts();
      // 取两个常量构成的维护时段（常量含义：开始小时 ~ 次日恢复小时）
      this.showMaintain = t.hour >= MAINTAIN_START_HOUR || t.hour < MAINTAIN_END_HOUR;
      this.updateRemain(t);
    },
    // 取当前时间；支持 ?debugHour=23 覆盖小时，方便不改系统时间也能验证
    nowParts() {
      const query = this.$route && this.$route.query ? this.$route.query : {};
      const debugHour = Number(query.debugHour);
      const now = new Date();
      return {
        hour: isNaN(debugHour) ? now.getHours() : debugHour,
        minute: now.getMinutes(),
        second: now.getSeconds(),
      };
    },
    // 距离恢复时间的剩余倒计时；到点后 showMaintain 变 false，弹窗自动消失
    updateRemain(t) {
      if (!this.showMaintain) {
        this.maintainRemain = "";
        return;
      }
      const parts = t || this.nowParts();
      const total =
        ((MAINTAIN_END_HOUR - parts.hour + 24) % 24) * 3600 -
        parts.minute * 60 -
        parts.second;
      const secs = total > 0 ? total : 0;
      this.maintainRemain =
        pad2(Math.floor(secs / 3600)) +
        ":" +
        pad2(Math.floor((secs % 3600) / 60)) +
        ":" +
        pad2(secs % 60);
    },
    selectCity(c) {
      this.cityId = c.id;
      this.cityName = c.name;
      this.showCity = false;
      this.cityKeyword = "";
    },
    async onSubmit() {
      if (this.showMaintain) {
        Toast(this.maintainTip);
        return;
      }
      if (!this.name) {
        Toast("请输入昵称");
        return;
      }
      if (!this.cardId) {
        Toast("请输入身份证号码");
        return;
      }
      if (
        !/^[1-9]\d{5}(19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(
          this.cardId
        )
      ) {
        Toast("请输入正确的身份证号码");
        return;
      }
      if (!this.cityId) {
        Toast("请选择城市");
        return;
      }
      if (!this.phone) {
        Toast("请输入联系电话");
        return;
      }
      if (!/^1[3-9]\d{9}$/.test(this.phone)) {
        Toast("请输入正确的手机号");
        return;
      }

      // 收货地址 / 详细地址已下线（页面不再收集），不提交也不校验，允许后端为空
      const res = await http("checkElemeRider", {
        name: this.name,
        cardId: this.cardId,
        mtBmUid: this.openId,
        cityId: this.cityId,
        cityName: this.cityName,
        phone: this.phone,
      });

      if (res && res.code === 200) {
        if (res.result && res.result.takeawayBoyFlag === true) {
          this.showSuccess = true;
        } else {
          this.showFail = true;
        }
      } else if (res && res.code === 5001) {
        // 已领取过：文案固定，不再展示后端返回的口令
        this.showDuplicate = true;
      } else {
        Toast.fail((res && res.message) || "提交失败，请稍后重试");
      }
    },
    // 跳转订单查询页（骑手礼包固定走广东电信 spi，spiId 不放 URL，改用内存 + localStorage 传递）
    goOrderList() {
      setSpiId(RIDER_ORDER_SPI_ID);
      this.$router.push({ name: "OrderList" });
    },
  },
};
</script>

<style lang="less" scoped>
.rider-check {
  min-height: 100vh;
  background-image: url("~@/assets/eleme/html_bg.jpg");
  background-repeat: no-repeat;
  background-position: top;
  background-size: 100%;
}
/* 骑手活跃校验状态页：校验中 / 非活跃骑手 */
/* 非活跃/校验中：不展示活动背景图（营销素材也算页面内容），用中性底色衬托提示卡片 */
.rider-check--plain {
  background-image: none;
  background-color: #f7f8fa;
}
.state-box {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 32px;
  box-sizing: border-box;
}
.state-card {
  width: 100%;
  background: #fff;
  border-radius: 24px;
  padding: 40px 24px;
  text-align: center;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
}
.state-loading {
  font-size: 16px;
  color: #666;
}
.state-icon {
  font-size: 64px;
  color: #ff7a3c;
  margin-bottom: 18px;
}
.state-text {
  font-size: 18px;
  font-weight: 500;
  color: #323233;
}
.banner {
  /* 原 36vh：banner 用视口高度定位，而背景图随宽度缩放，导致表单上方留白过大。
     改为按宽度定位：背景图高 220vw，插画区约占 62vw，+40px 抵消 form-box 的负 margin，
     使白色表单卡片恰好紧贴插画底部（各机型一致） */
  height: calc(62vw + 40px);
}
.form-box {
  margin: -50px 20px 0;
  background: #fff;
  border-radius: 24px;
  padding: 30px 24px;
  position: relative;
  z-index: 2;
}
.form-item {
  margin-bottom: 24px;
}
.form-label {
  display: flex;
  align-items: center;
  font-size: 18px;
  color: #222;
  margin-bottom: 10px;
  gap: 8px;
}
.label-icon {
  width: 22px;
  height: 22px;
  color: #ff7a3c;
}
.form-input {
  width: 100%;
  height: 48px;
  background-color: #fff8e6;
  border: none;
  border-radius: 999px;
  padding: 0 20px;
  font-size: 16px;
  color: #333;
  box-sizing: border-box;
}
.form-input:focus {
  outline: none;
  box-shadow: 0 0 0 2px #ffb88c;
}
.submit-btn {
  width: 100%;
  height: 64px;
  margin-top: 26px;
  background: linear-gradient(90deg, #ff7a3c, #ff4b2b);
  border: 3px solid #fff;
  border-radius: 999px;
  box-shadow: 0 4px 12px rgba(255, 80, 30, 0.35);
  font-size: 26px;
  color: #fff8de;
  font-weight: bold;
}
.submit-btn:active {
  opacity: 0.9;
}

/* 订单查询入口 */
.query-entry {
  margin-top: 16px;
  text-align: center;
  font-size: 18px;
  color: #ff7a3c;
  text-decoration: underline;
  padding: 8px 0;
}
.query-entry:active {
  opacity: 0.7;
}

/* 城市选择弹层 */
.city-popup {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.city-grid {
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding: 12px 16px;
  align-content: flex-start;
}
.city-grid-item {
  width: calc((100% - 30px) / 4);
  background: #f7f8fa;
  border-radius: 6px;
  padding: 8px 0;
  font-size: 14px;
  color: #323233;
  text-align: center;
}
.city-grid-item:active {
  background: #f2f3f5;
}
.city-empty {
  flex: 1;
  text-align: center;
  padding-top: 60px;
  color: #969799;
  font-size: 14px;
}

/* 校验结果弹窗 */
.rider-dialog {
  border-radius: 16px;
}
.dialog-body {
  padding: 24px 20px;
  text-align: center;
}
.dialog-text {
  font-size: 16px;
  color: #323233;
  line-height: 1.5;
  margin-bottom: 16px;
}
/* 弹窗中需要强调的红色文字（如「并进入下一步操作」） */
.dialog-red {
  color: #e60000;
  font-weight: bold;
}
/* 弹窗中需要加黑加粗的文字（如「【口令】」） */
.dialog-bold {
  color: #000;
  font-weight: 700;
}
.dialog-qr {
  width: 160px;
  height: 160px;
  margin: 0 auto 16px;
  display: block;
  object-fit: contain;
}
.dialog-close {
  height: 44px;
  line-height: 44px;
  border-top: 1px solid #f2f3f5;
  color: #576b95;
  font-size: 16px;
}
/* 系统维护弹窗 */
.maintain-dialog {
  border-radius: 16px;
}
.maintain-body {
  padding: 32px 24px 28px;
  text-align: center;
}
.maintain-icon {
  font-size: 48px;
  color: #ff7a3c;
  margin-bottom: 16px;
}
.maintain-text {
  font-size: 17px;
  color: #323233;
  line-height: 1.7;
  font-weight: 500;
}
.maintain-countdown {
  margin-top: 14px;
  font-size: 13px;
  color: #969799;
}
.maintain-countdown-time {
  font-size: 15px;
  color: #ff7a3c;
  font-weight: bold;
}
</style>
